import { AbstractLocaleMessageObject } from "@/i18n/AbstractLocaleMessageObject"

export class ApiConnectionInfoJa extends AbstractLocaleMessageObject {
  readonly companyId = "加盟店ID"
  readonly applicationId = "接続元ID"
  readonly secret = "シークレットキー"
  readonly model = "審査モデル"
}
